module.exports = "/_next/static/images/hn-7e936f52f27aedab89ae1ec6f7b503bb.svg";